import { useEffect } from 'react';
import { useChatStore } from '../store/chat-store';

const AUTO_DISMISS_MS = 5_000;

/**
 * Slim inline notice shown when a message is blocked by moderation.
 * Auto-dismisses after a few seconds; clicking it dismisses immediately.
 */
export function BlockedToast() {
  const toast = useChatStore(s => s.blockedToast);
  const dismiss = useChatStore(s => s.setBlockedToast);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => dismiss(null), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [toast, dismiss]);

  if (!toast) return null;

  return (
    <button
      type="button"
      onClick={() => dismiss(null)}
      className="absolute left-3 right-3 bottom-20 z-30 flex items-start gap-2 rounded-xl bg-amber-50 ring-1 ring-amber-300/60 px-3 py-2 text-left text-xs text-amber-900 shadow-md hover:bg-amber-100 transition"
      aria-live="polite"
    >
      <span className="mt-0.5">⚠️</span>
      <span className="flex-1">{toast.reason}</span>
      <span className="text-amber-500 hover:text-amber-700" aria-hidden="true">✕</span>
    </button>
  );
}
